import { Divider } from '@mui/material'
import React from "react"
import { Link } from 'react-router-dom'
import history from './../history'

import './Footer.css'

export default function Footer() {

  return (
    <div className="footer">
      <Divider />
      <div className="footerContent">
        <span>
          Althub ©{new Date().getFullYear()}  All rights reserved.
        </span>
        <Link to="/disclaimer" onClick={() => history.push('/disclaimer')}>
          Disclaimer
        </Link>
        <Link to="/termsOfUse" onClick={() => history.push('/termsOfUse')}>
          Terms of Use
        </Link>
        <Link to="/privacyPolicy" onClick={() => history.push('/privacyPolicy')}>
          Privacy Policy
        </Link>
      </div>
    </div>
    )
}
